export function transformFilteredPracticeData(raw) {
  const {
    id,
    pname,
    pnumber,
    title,
    descriptn,
    pdflink,
    notes,
    updatedAt,
    cpsequence,
    score,
    scoreClassName,
    scoreLabel,
    isMostCommon,
    general,
    continous,
    crep,
    crepInfo, // ✅ Include this so it's available at top level

    // Contract periods
    cntrctpd,
    cntrctprdthrucontinous,
    cntrctprdthruheli,
    cntrctprdthruwellhead,
    cntrctprdthrufwp,
    cntrctprdthrusafe,
    cntrctprdthruclear30,

    // Incentives
    ["32_5_p_sip"]: sip32,
    ["50_p_pip"]: pip50,
    ["20_p_rr_incentive"]: rental20,
    sipthrucontinous,
    pipthrucontinous,
    rentalrateincentivethrucontinuous,
    sipthruheli,
    pipthruheli,
    sipthruwellhead,
    pipthruwellhead,
    sipthrufwp,
    pipthrufwp,
    rentalrateadjthrufwp,
    sipthrusafe,
    pipthrusafe,
    rentalrateincentivesafe,
    sipthruclear30,
    pipthruclear30,
    rentalrateadjthruclear30,
    waterqualitythruclear30,

    // Practice details
    maintenance,
    maintenanceforclear30,
    maintenance_incentive,
    management,
    costshareavble,
    costsharenotavble,
    eligibilityforheli,
    eligiblityforwellhead,
    eligiblitythrucontinuous,
    eligiblitythruclear30,
    eligiblitythrufwp,
    eligiblitythrugeneral,
    eligibilitythrugrassland,


    priorityrating = {},

    // Land + priority flags
    ...flags
  } = raw;

  const programs = [
    {
      name: title?.toLowerCase().includes("cp88")
        ? "Grassland CRP Signup"
        : "General Signup",
      period: cntrctpd,
      incentives: {
        sip: sip32,
        pip: pip50,
        rentalRateIncentive: rental20,
        rentalRateAdj: false, 
      },
    },
    {
      name: "Continuous Signup",
      period: cntrctprdthrucontinous,
      incentives: {
        sip: sipthrucontinous,
        pip: pipthrucontinous,
        rentalRateIncentive: rentalrateincentivethrucontinuous,
        rentalRateAdj: false,
      },
    },
    {
      name: "HELI",
      period: cntrctprdthruheli,
      incentives: {
        sip: sipthruheli,
        pip: pipthruheli,
        rentalRateIncentive: false,
        rentalRateAdj: false,
      },
    },
    {
      name: "Wellhead Protection",
      period: cntrctprdthruwellhead,
      incentives: {
        sip: sipthruwellhead,
        pip: pipthruwellhead,
        rentalRateIncentive: false,
        rentalRateAdj: false,
      },
    },
    {
      name: "Farmable Wetland Program",
      period: cntrctprdthrufwp,
      incentives: {
        sip: sipthrufwp,
        pip: pipthrufwp,
        rentalRateIncentive: false,
        rentalRateAdj: rentalrateadjthrufwp,
      },
    },
    {
      name: "SAFE",
      period: cntrctprdthrusafe,
      incentives: {
        sip: sipthrusafe,
        pip: pipthrusafe,
        rentalRateIncentive: rentalrateincentivesafe,
        rentalRateAdj: false,
      },
    },
    {
      name: "CLEAR30",
      period: cntrctprdthruclear30,
      incentives: {
        sip: sipthruclear30,
        pip: pipthruclear30,
        rentalRateIncentive: false,
        rentalRateAdj: rentalrateadjthruclear30,
        waterqualitythruclear30,
      },
    },
  ];

  const filteredPrograms = programs.filter(
    (p) =>
      p.period ||
      Object.values(p.incentives).some(
        (v) => v && v !== "0" && v !== "false" && v !== "NA"
      )
  );

  const LANDCOVER_KEYS = [
    "aquaculture",
    "cropland",
    "grassland",
    "pasture",
    "timber",
    "wetland",
  ];

  const PRIORITY_KEYS = [
    "winderosion",
    "watererosion",
    "soilhealth",
    "excesswind",
    "drought",
    "flooding",
    "snowdrift",
    "waterquality",
    "aquatic",
    "biggame",
    "grasslandbirds",
    "forestbirds",
    "pollinators",
    "waterfowl",
    "carbonstorage",
    "priorityecosystem",
  ];

  const landcover = LANDCOVER_KEYS.filter((key) => Boolean(flags[key]));

  const priorities = PRIORITY_KEYS.filter((key) => {
    const rating = priorityrating[key];
    return rating && rating !== "0" && rating !== 0;
  }).map((key) => ({
    name: key,
    rating: Number(priorityrating[key]),
  }));

  const practiceDetails = {
    descriptn,
    notes,
    costshareavble,
    costsharenotavble,
    maintenance,
    maintenanceforclear30,
    maintenance_incentive,
    management,
    eligibilityforheli,
    eligiblityforwellhead,
    eligiblitythrucontinuous,
    eligiblitythruclear30,
    eligiblitythrufwp,
    eligiblitythrugeneral,
    eligibilitythrugrassland
  };

  Object.keys(practiceDetails).forEach(
    (key) => !practiceDetails[key] && delete practiceDetails[key]
  );

  return {
    id,
    cpsequence,
    isMostCommon,
    score,
    scoreClassName,
    scoreLabel,
    title,
    updatedAt,
    practiceName: pname,
    practiceNumber: pnumber,
    pdfLink: pdflink?.replace(/\"/g, ""),
    general,
    continuous: continous,
    crep,
    crepInfo,
    practiceDetails,
    programs: filteredPrograms,
    priorities,
    landcover,
  };
}
